import Api from '../../shared/Api';

export default class TemplatesApi {
    static getTemplates() {
        return new Api().get('/views/templates');
    }

    static editTemplate(key: number) {
        return new Api().get(`/views/templates/${key}/edit`);
    }

    static updateTemplate(key: string, data: any) {
        return new Api().put(`/views/templates/${key}`, data);
    }
}
